<template>
  <div
    class="timeline-break"
    :class="{ 'start-border': startVisible, 'end-border': endVisible }"
    :style="breakStyle"
  >
    <!-- Bad behaviour for short stream breaks - text not fit -->
    <!--<span class="break-message">Stream Failed</span>-->
  </div>
</template>

<script>
// @group Timeline
// Stream break area on timeline
export default {
  name: "TimelineBreak",
  props: {
    /** start relative position */
    start: {
      type: Number,
      required: true,
      validator(start) {
        return start <= 1;
      }
    },
    /** end relative position */
    end: {
      type: Number,
      required: true,
      validator(end) {
        return end >= 0;
      }
    },
    /** borders width */
    borderWidth: {
      type: Number,
      default: 3
    }
  },
  computed: {
    // @vuese
    // Is start in visible range
    startVisible() {
      return this.start >= 0;
    },
    // @vuese
    // Is end in visible range
    endVisible() {
      return this.end <= 1;
    },
    // @vuese
    // Start in range 0-1
    boundedStart() {
      return Math.max(this.start, 0);
    },
    // @vuese
    // End in range 0-1
    boundedEnd() {
      return Math.min(this.end, 1);
    },
    // @vuese
    // Start in range 0-100
    startPercentage() {
      return this.boundedStart * 100;
    },
    // @vuese
    // End in range 0-100
    endPercentage() {
      return this.boundedEnd * 100;
    },
    // @vuese
    // Area width in range 0-100
    widthPercentage() {
      return this.endPercentage - this.startPercentage;
    },
    // @vuese
    // Break area left position styling parameter
    leftStyle() {
      return this.startPercentage + "%";
    },
    // @vuese
    // Break area width styling parameter
    widthStyle() {
      return this.widthPercentage + "%";
    },
    borderWidthStyle() {
      return this.borderWidth + "px";
    },
    // @vuese
    // Break area dynamic styles
    breakStyle() {
      return {
        width: this.widthStyle,
        left: this.leftStyle,
        "border-width": this.borderWidthStyle
      };
    }
  }
};
</script>

<style scoped>
.timeline-break {
  position: absolute;
  height: 100%;

  box-sizing: border-box;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(255, 0, 0, 0.7);
  z-index: var(--timeline-break-z);
}

/**.break-message {
  height: auto;
  text-transform: uppercase;
  font-weight: bold;
  line-height: 1.5em;
}*/

.start-border {
  border-left-style: dashed;
  border-left-color: white;
}

.end-border {
  border-right-style: dashed;
  border-right-color: white;
}
</style>
